

















import {Component, Prop, Vue} from 'vue-property-decorator';
import {nil} from '@/common';

@Component({
    components: {},
})
export default class NumberStepper extends Vue {
    @Prop({default: 1})
    private min!: number;
    @Prop({default: 100})
    private max!: number;
    @Prop({default: 1})
    private step!: number;
    @Prop({default: 'fas fa-plus'})
    private upIcon!: string;
    @Prop({default: 'fas fa-minus'})
    private downIcon!: string;
    @Prop({default: 0})
    private value!: number;
    @Prop({default: false})
    private vertical!: boolean;
    @Prop({default: false})
    private editable!: boolean;
    @Prop({default: 0})
    private fixedSize!: number;
    @Prop({default: 250})
    private holdSpeed!: number;
    @Prop({default: true})
    private margins!: boolean;
    @Prop({default: false})
    public disabled!: boolean;
    @Prop({default: () => null})
    public customSteps!: string[];

    private inputSize = 0;
    private editedValue = null;
    private editMode = false;
    private pressAndHold: any = null;

    private startIncr() {
        this.pressAndHold = setInterval(() => {
            this.incr();
        }, this.holdSpeed);
    }

    private stopIncr() {
        clearInterval(this.pressAndHold);
    }

    private startDecr() {
        this.pressAndHold = setInterval(() => {
            this.decr();
        }, this.holdSpeed);
    }

    private stopDecr() {
        clearInterval(this.pressAndHold);
    }

    private incr() {
        const newValue = this.value + this.step;
        if (newValue > this.max) {
            this.$emit('onMax');
        } else {
            this.$emit('input', newValue);
        }
    }

    private decr() {
        const newValue = this.value - this.step;
        if (newValue < this.min) {
            this.$emit('onMin');
        } else {
            this.$emit('input', newValue);
        }
    }

    public triggerEdit() {
        if (this.disabled || !this.editable) { return; }
        this.sizeInput();
        this.editMode = true;
        this.editedValue = this.displayValue;
        setTimeout(() => {
            (this.$refs.editField as any).select();
            (this.$refs.editField as any).focus();
        }, 250);
    }
    private edit(andProceed = false) {
        if (this.disabled) { return; }
        const n = Number(this.editedValue);
        if (!isNaN(n) && n >= this.min && n <= this.max) {
            this.$emit('input', n);
        }
        this.editMode = false;
        if (andProceed) {
            this.$emit('onProceed');
        }
    }
    private get displayValue() {
        if (this.disabled) { return '-'.repeat(this.fixedSize || 1); }
        if (!nil(this.customSteps)) { return this.customSteps[this.value]; }
        if (this.fixedSize === 0) { return this.value; }
        const addZero = this.fixedSize - this.value.toString().length;
        if (addZero <= 0) { return this.value; }
        return `${'0'.repeat(addZero)}${this.value}`;
    }
    public mounted() {
        this.onResize(() => {
            this.sizeInput();
        });
        this.sizeInput();
    }
    private sizeInput() {
        if (nil(this.$el)) { return; }
        this.inputSize = this.$el.clientWidth;
    }
}
